export default __webpack_public_path__ + "fd69edc8826f0733bdad0a718fa9da48.png";